import React from 'react';
import { IconBase } from '../Base';
export const IconIndeterminate = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M6 10H14", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Indeterminate.js.map